import { Component, OnInit } from '@angular/core';
import { Jezik } from './jezik';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-jezik',
  templateUrl: './jezik.component.html'
})
export class JezikComponent 
extends BaseModalContainer<Jezik> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Jezik>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
